import Button from '@/shared/components/button/Button';

type BouncySumsTableGridProps = {
	availableTables: number[];
	selectedTables: number[];
	onTableToggle: (table: number) => void;
};

const BouncySumsTableGrid = ({ availableTables, onTableToggle, selectedTables }: BouncySumsTableGridProps) => {
	return (
		<div className="bouncy-sums-start-screen__table-grid">
			{availableTables.map((table) => {
				const selected = selectedTables.includes(table);

				return (
					<Button
						key={table}
						btnType="button"
						type="primary"
						color="sea"
						title={String(table)}
						onClick={() => onTableToggle(table)}
						tabIndex={0}
						testId={`bouncy-sums-table-${table}`}
						pressed={selected}
						className="bouncy-sums-start-screen__table-button"
					/>
				);
			})}
		</div>
	);
};

export default BouncySumsTableGrid;
